import { endpoints } from 'api/endpoints'
import { GetArrayResponse } from 'interfaces/api.interfaces'
import { TetrisDefaultPrice, TetrisDefaultPriceBase } from 'interfaces/api/tetrisDefaultPrices.interfaces'
import { axios } from 'modules/axios'

const getAll = async (): GetArrayResponse<TetrisDefaultPrice> => {
  const { data: response } = await axios.request<TetrisDefaultPrice[]>({
    method: 'GET',
    url: endpoints.tetrisDefaultPrices.getAll(),
  })
  return response
}

const update = async (optimilkParams: TetrisDefaultPriceBase[]): Promise<void> => {
  await axios.request({
    method: 'PATCH',
    url: endpoints.tetrisDefaultPrices.update(),
    data: { optimilkParams },
  })
}

export const tetrisDefaultPricesApi = {
  getAll,
  update,
}
